import { render, staticRenderFns } from "./ScrollViewItem.vue?vue&type=template&id=1b650e0a&scoped=true&"
import script from "./ScrollViewItem.vue?vue&type=script&lang=js&"
export * from "./ScrollViewItem.vue?vue&type=script&lang=js&"
import style0 from "./ScrollViewItem.vue?vue&type=style&index=0&id=1b650e0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b650e0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b650e0a')) {
      api.createRecord('1b650e0a', component.options)
    } else {
      api.reload('1b650e0a', component.options)
    }
    module.hot.accept("./ScrollViewItem.vue?vue&type=template&id=1b650e0a&scoped=true&", function () {
      api.rerender('1b650e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/ScrollViewItem.vue"
export default component.exports